<div *ngIf="label.length > 0" #tooltip [ngClass]="tooltipClass" [ngStyle]="{ width: width }" role="tooltip" [id]="id">
  <div #contentContainer class="content-container">
    <span #content>{{ label }}</span>
  </div>
  @if (showArrow) {
    <div class="arrow"></div>
  }
</div>
